import React, { useState } from "react";
import { CheckCheck, ArrowUpLeft } from "lucide-react";
import { Panel, SEVERITY } from "./ui";

const SEVERITY_ORDER = { critical: 0, high: 1, medium: 2, low: 3 };

const AlertsPanel = ({ data, loading, error, onRetry, onResolve }) => {
  const [resolvedIds, setResolvedIds] = useState([]);

  const visible = (data || [])
    .filter((a) => !resolvedIds.includes(a.id))
    .sort((a, b) => SEVERITY_ORDER[a.severity] - SEVERITY_ORDER[b.severity]);

  const resolve = (id) => {
    setResolvedIds((ids) => [...ids, id]);
    onResolve?.(id);
  };

  return (
    <Panel
      eyebrow="דורש טיפול"
      title="התראות ופעולות פתוחות"
      subtitle={`${visible.length} התראות ממתינות`}
      accent="rose"
      loading={loading}
      error={error}
      onRetry={onRetry}
      empty={!loading && !error && visible.length === 0}
      emptyText="אין התראות פתוחות כרגע 🎉"
    >
      <ul className="divide-y divide-gray-100">
        {visible.map((a) => (
          <li key={a.id} className="py-2.5 flex items-start justify-between gap-3">
            <div className="min-w-0">
              <div className="flex items-center gap-1.5 flex-wrap">
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ring-1 ${SEVERITY[a.severity].chip}`}>
                  {SEVERITY[a.severity].label}
                </span>
                <span className="text-[10px] text-gray-400">{a.createdAt}</span>
              </div>
              <p className="text-xs text-gray-700 mt-1">{a.label}</p>
            </div>
            <div className="flex items-center gap-1.5 flex-shrink-0">
              <a
                href={a.href}
                className="inline-flex items-center gap-1 text-[11px] font-bold text-indigo-600 hover:text-indigo-800"
              >
                טיפול <ArrowUpLeft className="w-3 h-3" />
              </a>
              <button
                onClick={() => resolve(a.id)}
                title="סמן כטופל"
                className="w-6 h-6 flex items-center justify-center rounded-full text-emerald-600 hover:bg-emerald-50"
              >
                <CheckCheck className="w-3.5 h-3.5" />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </Panel>
  );
};

export default AlertsPanel;
